<div>
  <div class="form-container" *ngFor="let field of fields">
    <ng-container [ngSwitch]="field.type" *ngIf="!field.hidden">
      <ng-container *ngSwitchCase="'group'">
        <app-form-fields-sub [fields]="field.fields" [model]="model[field.id] ?? {}" [group]="group.get(field.id)"></app-form-fields-sub>
      </ng-container>
      <ng-container *ngSwitchCase="'array'">
        <div *ngFor="let subgroup of group.get(field.id).controls; let i = index">
          <app-form-fields-sub [fields]="field.fields" [model]="model[field.id][i] ?? {}" [group]="subgroup"></app-form-fields-sub>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <app-form-field *ngIf="!field.readOnly && !field.noFormControl" [field]="field" [formGroup]="group"></app-form-field>
        <app-form-field-readonly *ngIf="field.readOnly" [field]="field" [value]="model[field.id]"></app-form-field-readonly>
      </ng-container>
    </ng-container>
  </div>
</div>
